import { assocPath, mergeDeepRight } from 'ramda'
import thunk from 'redux-thunk'
import { createReducer } from 'reduxsauce'

import FetchingMiddleware from '../services/FetchingMiddleware'
import type { TherapistStateType } from '../types/TherapistStateType'
import { createTypedActions } from './redux.utils'

/* ------------- Types and Action Creators ------------- */

const ACTIONS = {
  onChangeTherapistValue: ['path', 'value'],
  onMergeTherapistValue: ['value'],
  getAllClientsRequest: null,
  addScheduleRequest: ['data'],
  editScheduleRequest: ['id', 'data'],
  deleteScheduleRequest: ['id'],
  getScheduleRequest: null,
  getTherapistDataRequest: ['therapistUserId'],
  getTherapistCalendarToken: ['therapistId'],
  updateTherapistDataRequest: ['data'],
}

const { Types, Creators } = createTypedActions<keyof typeof ACTIONS>(ACTIONS)

// ======================================================
// Middleware Configuration
// ======================================================
const middleware = [thunk]

middleware.push(FetchingMiddleware as any)

const TherapistActions = Creators
export const TherapistTypes = Types
export default TherapistActions

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  reviews: [],
  clients: [],
  schedule: [],
  appointments: [],
}

/* ------------- Reducers ------------- */

export const onChangeTherapistValueR = (
  state: TherapistStateType,
  { path, value }: { path: string; value: object | string | boolean | number },
): TherapistStateType => assocPath(path.split('.'), value, state)

export const onMergeTherapistValueR = (
  state: TherapistStateType,
  { value }: { value: object | boolean | number | string },
): TherapistStateType => mergeDeepRight(state, value)

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ON_CHANGE_THERAPIST_VALUE]: onChangeTherapistValueR,
  [Types.ON_MERGE_THERAPIST_VALUE]: onMergeTherapistValueR,
  [Types.GET_ALL_CLIENTS_REQUEST]: (state) => state,
  [Types.ADD_SCHEDULE_REQUEST]: (state) => state,
  [Types.EDIT_SCHEDULE_REQUEST]: (state) => state,
  [Types.DELETE_SCHEDULE_REQUEST]: (state) => state,
  [Types.GET_SCHEDULE_REQUEST]: (state) => state,
  [Types.GET_THERAPIST_DATA_REQUEST]: (state) => state,
  [Types.UPDATE_THERAPIST_DATA_REQUEST]: (state) => state,
} as any)
